import React, { useEffect, useState } from "react";
import { getFirestore } from "../../config/firebase";
import logoWhatsapp from "../../assets/logoWhatsapp.png";
import "./whatsapp.scss";
import WhatsAppModal from "./WhatsAppModal";
import useFirestoreUpdate from "../../config/useFirestoreData";
import { getSavedTrackingParams, saveTrackingParams, resolveSuborigen, CONTACT_ENTRY } from "../../utils/utmTracker";
import { saveUtmParams, getCurrentUrlWithUtmDefaults, urlSinUtmsPrincipales } from "../../config/whatsappConfig";

const WhatsAppFlotante = () => {
  const [numerosWhatsapp, setNumerosWhatsapp] = useState([]);
  const [mostrarWhatsapp, setMostrarWhatsapp] = useState(false);

  const [whatsappIndividual, setWhatsappIndividual] = useState(null);

  // useEffect(() => {
  //   const db = getFirestore();
  //   const vehicles = db.collection("fiat-informacion");

  //   vehicles.get().then((querySnapshot) => {
  //     const datosCompletos = querySnapshot.docs.map((doc) => ({
  //       ...doc.data(),
  //       id: doc.id,
  //     }));
  //     setWhatsappIndividual(datosCompletos[1].url);
  //     setNumerosWhatsapp(datosCompletos[1].numeros);
  //     setMostrarWhatsapp(datosCompletos[1].mostrar);
  //   });
  // }, []);

  useEffect(() => {
    const cargarDatosInformacion = async () => {
      // Intentar recuperar los datos desessionStorage
      const datosLocales = sessionStorage.getItem("fiat-informacion");
      if (datosLocales) {
        // Si los datos existen, parsearlos y establecer los estados correspondientes
        const datosCompletos = JSON.parse(datosLocales);
        setWhatsappIndividual(datosCompletos[1].url);
        setNumerosWhatsapp(datosCompletos[1].numeros);
        setMostrarWhatsapp(datosCompletos[1].mostrar);
      } else {
        // Si no hay datos ensessionStorage, hacer la llamada a Firestore
        const db = getFirestore();
        const vehicles = db.collection("fiat-informacion");
        try {
          const querySnapshot = await vehicles.get();
          const datosCompletos = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
          // Actualizar los estados con los datos de Firestore
          setWhatsappIndividual(datosCompletos[1].url);
          setNumerosWhatsapp(datosCompletos[1].numeros);
          setMostrarWhatsapp(datosCompletos[1].mostrar);
          // Guardar los datos ensessionStorage
          sessionStorage.setItem("fiat-informacion", JSON.stringify(datosCompletos));
        } catch (error) {
          console.error("Error al obtener datos de Firestore: ", error);
        }
      }
    };

    // Ejecutar la función de carga de datos
    cargarDatosInformacion();
  }, []);

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      saveTrackingParams(); // Asegurar que tenemos los UTMs más recientes
      saveUtmParams();
      const tracking = getSavedTrackingParams();
      const hadPrincipalUtms = !urlSinUtmsPrincipales(window.location.search);
      await updateData({
        ...values,
        contact_entry: CONTACT_ENTRY.WHATSAPP,
        SubOrigen: resolveSuborigen(
          hadPrincipalUtms ? { utm_medium: tracking.utm_medium } : { utm_medium: "" },
          CONTACT_ENTRY.WHATSAPP
        ),
        GCLID: tracking.gclid ?? "",
        ConsultaOrigenId: tracking.utm_term ?? "",
      });
      setOpen(false);
      const urlWithUtm = getCurrentUrlWithUtmDefaults();

      // Construir el mensaje de WhatsApp
      const whatsappMessage = `Hola, me gustaría hacer una consulta.\n${urlWithUtm}`;
      const encodedMessage = encodeURIComponent(whatsappMessage);
      window.location.href = `https://api.whatsapp.com/send?phone=5493513525903&text=${encodedMessage}`;
    } catch (error) {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  if (!mostrarWhatsapp) {
    return null;
  }

  return (
    <div className="whatsapp-container">
      <WhatsAppModal open={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} loading={loading} />
      <button className="btn-whatsapp-flotante" onClick={() => setOpen(true)} disabled={loading}>
        <img src={logoWhatsapp} alt="whatsapp" />
      </button>
    </div>
  );
};
export default WhatsAppFlotante;
